








































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from "vuex-class";
import requestService from "@/service/requestService";
import { ReservationDetail, Customer } from "@/model/ReservationDetail";
import { Uketsuke } from "@/model/Uketsuke";
import { SknUketsukeExtends } from "@/model/SknUketsukeExtends";
import { ConfirmationBeforeEntry } from "@/model/ConfirmationBeforeEntry";
import { Utils } from "@/service/util";
import InputNumber from "@/components/common/input/InputNumber.vue";
import InputString from "@/components/common/input/InputString.vue";
import ReservationDetailState from "@/store/reservation/state";
import Header from "@/components/Header.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { Staff } from "@/model/Staff";
import moment from "moment";
import { MESSAGE } from "@/model/Message";
import { CustomerService } from "@/service/CustomerService";
import { ElButton } from "element-ui/types/button";
import { SubHeaderData } from "@/model/SubHeaderData";
import { UserService } from "@/service/UserService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import { SocketControllers } from "@/service/SocketControllers";
import { Support } from "@/model/Support";
import Number from "@/shared/filters/Number";
import { KbnSkn } from "@/model/KbnSkn";
import { CarSelectData } from "@/model/CarSelection";
import InputCode from "@/components/common/input/InputCode.vue";
import InspectionDetailContent from "@/components/InspectionDetailContent.vue";
import EstimateDetailContent from "@/components/EstimateDetailContent.vue";
import CarSelectionContent from "@/components/CarSelectionContent.vue";
import ExtendsImageTabsContent from "@/components/ExtendsImageTabsContent.vue";
import EstimateInspectionCostComponent from "@/components/EstimateInspectionCostComponent.vue";
import NextageFooter from "@/components/nextageFooter.vue";
import ReferReservation from "@/components/ReferReservation.vue";
import { ScreenTab } from "@/model/ScreenTab";
import { InspectionDetailStoreService } from "@/service/InspectionDetailStoreService";
import { InspectionShakenShuruiDetailStoreService } from "@/service/InspectionShakenShuruiDetailStoreService";
import { InspectionJizenDetailStoreService } from "@/service/InspectionJizenDetailStoreService";
import { ShakenStorage } from "@/service/storage";

const namespace: string = "ReservationDetail";
@Component({
  components: {
    Header,
    InputNumber,
    InputString,
    ConfirmDialog,
    InputCode,
    InspectionDetailContent
    , EstimateDetailContent
    , CarSelectionContent
    , ExtendsImageTabsContent
    , EstimateInspectionCostComponent
    , NextageFooter
    , ReferReservation
  },
  filters: {
    Number
  }
})

/*================================================================= *
*  車検前画面
* ================================================================= */
export default class CustomerScreen extends Vue {
  @Prop() code: string;
  @State("ReservationDetail") state: ReservationDetail;
  @Action("init", { namespace })
  initStore: any;
  @Action("updateSoukouKm", { namespace })
  updateSoukouKm: any;
  @Action("updateSoukouKmAvg", { namespace })
  updateSoukouKmAvg: any;
  @Action("updateSoukouMile", { namespace })
  updateSoukouMile: any;
  @Action("updateSoukouMileAvg", { namespace })
  updateSoukouMileAvg: any;
  @Action("updateSoukouUnitKbn", { namespace })
  updateSoukouUnitKbn: any;
  @Action("updateSoukouBikouKbn", { namespace })
  updateSoukouBikouKbn: any;
  @Action("updateLaborRate", { namespace })
  updateLaborRate: any;
  @Action("initSupport", { namespace })
  initSupport: any;
  @Action("updateMemo", { namespace })
  updateMemo: any;
  @Action("updateFrontStaff", { namespace })
  updateFrontStaff: any;
  @Action("updateOmonaYouto", { namespace })
  updateOmonaYouto: any;
  @Getter("currentState", { namespace })
  currentState: ReservationDetailState;
  @Getter("uketsukeExtendsId", { namespace })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace })
  yoyakuNo: string;
  @Getter("frontStaff", { namespace })
  storeFrontStaff: string;
  @Getter("isLoadUketsuke", { namespace })
  isLoadUketsuke: boolean;

  @Action("setEnvironment", { namespace: "Environment" })
  setEnvironment: any;
  @Getter("environment", { namespace: "Environment" })
  environment: any;

  @Action("setTimeFromSubHeaderData", { namespace: "SubHeader" })
  setTimeFromSubHeaderData: any;

  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;
  @Getter("stateId", { namespace: "SubHeader" })
  workProgressStateId: any;

  @Action("updateConfirmation", { namespace })
  updateConfirmation: any;

  @Action("updateSoukou", { namespace: "CarSelection" })
  updateSoukouMD3: any;

  @Action("updateSoukouMile", { namespace: "CarSelection" })
  updateSoukouMileMD3: any;

  @Action("updateSoukouUnitKbn", { namespace: "CarSelection" })
  updateSoukouUnitKbnMD3: any;

  @Action("updateSoukouBikouKbn", { namespace: "CarSelection" })
  updateSoukouBikouKbnMD3: any;

  @Getter("currentState", { namespace: "CarSelection" })
  carSelection: CarSelectData;
  @Action("setState", { namespace: "CarSelection" })
  setCarSelection: any;

  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;
  /** 2021-08-19 sh #7350 it get jizen-mitsumori after recieved socket(payments). [END] */
  @Getter("isShowMaintepack", { namespace: "FunctionSetting" })
  isShowMaintepack: any;

  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  @Getter("screenTabListFactory", { namespace: "FunctionSetting" })
  screenTabListFactory: any;
  @Getter("screenTabListUser", { namespace: "FunctionSetting" })
  screenTabListUser: any;
  /** 2024-05-02 nextage [END] */
  @Getter("isReferReservation", { namespace: "FunctionSetting" })
  isReferReservation: any;

  inspectionDetailStore: InspectionDetailStoreService =
    new InspectionDetailStoreService();
  inspectionDetailStoreService1: InspectionShakenShuruiDetailStoreService =
    new InspectionShakenShuruiDetailStoreService();
  inspectionDetailStoreService2: InspectionJizenDetailStoreService = new InspectionJizenDetailStoreService();

  finishLoad: boolean = false;
  isEdit: boolean = false;
  screenTab: ScreenTab[] = [];
  currentTab: number = 0;
  data: any = {};
  reqService: requestService;
  ippanSeibiService: IppanSeibiService;
  sktControll: SocketControllers;
  memo: string = "";
  // timeoutMemo: any;
  staffs: Staff[] = [];
  frontStaff: string = "";
  frontStaffNm: string = "";
  isUserMode: boolean = false;
  soukouKm: number = 0;
  omonaYoutoCd: any = null;
  omonaYoutoNm: string = "";
  omonaYoutos: any[] = [];
  kbnConfirmations: any = [];
  timerWs: any = null;
  kyotenCd: string = "";
  isLoadConfirmation: boolean = false;
  confirmations: ConfirmationBeforeEntry[] = [];
  errorMsg: string = "";
  service: CustomerService;
  loadingText: string = MESSAGE.Loading;
  isRestart: boolean = false;
  displayDialogSupport: boolean = false;
  supportSelected: any = null;
  displayDialogConfirmationBeforeEntry: boolean = false; // 入庫前確認ダイアログ表示フラグ
  displayDialogLaborRate: boolean = false;
  offNotify: boolean = false;
  // laborRateKingakuZn: number| null = null;
  laborSelected: any = null;
  labors: any = [];
  soukouBikouList: any = [];
  soukouUnitList: any = [];
  soukouUnitKbn: number | null = null;
  soukouBikouKbn: number | null = null;
  soukouMile: number = 0;
  kbnJidousha: any = [];
  kbnSkns: KbnSkn[][] = [[], [], [], [], [], [], []];
  carForm: CarSelectData = {} as CarSelectData;
  kbnTitles: string[] = [
    "skn_youto",
    "skn_kudou_houshiki",
    "skn_fuel_kbn",
    "skn_shift_kbn",
    "skn_meter_panel_alert",
    "skn_brake",
    "skn_saitei_chijou_kou_kbn"
  ];
  shashuRenban: any = null;
  questionnaireList: any = [];
  timerGetQuestionare: any = null;
  reInitMd2: boolean = false;
  statusBoxHeight: number | null = null;
  statusBoxResizeObserver: any = null;

  shouhiyou: any = {
    houteiHiyou: {
      zeiJibaisekiZk: 0,
      zeiWeightTax: 0,
      zeiInshidaiZk: 0
    },
    kensaHiyou: {
      subTotalZk: 0
    },
    shakenHiyou: { subTotalZk: 0 }
  };


  isExceed: boolean = false;
  tempKm: any = null;
  tempMile: any = null;

  
  showDialogReferCheck: boolean = false;
  dialogOk: boolean = false;
  referReservationCnt: number = 0;
  disableReferReservation: boolean = false;
  usedReferReservation: boolean = false;

  isExitConnectSocket: boolean = false;
      
  $refs!: {
  //  memoDialog: ConfirmDialog;
  //  inputMemo: InputString;
    inputSoukouKm: InputNumber;
    startDialog: ConfirmDialog;
    errorDialog: ConfirmDialog;
    btnSoukouDialog: ElButton;
    inputSoukouKmDialog: InputNumber;
    inputLaborRateDialog: InputNumber;
    btnLaborRateDialog: ElButton;
    inspectionDetail: InspectionDetailContent;
    estimateDetail: EstimateDetailContent;
    carSelection: CarSelectionContent;
    cancelDialog: ConfirmDialog;
    dialog: ConfirmDialog;
    referReservation: ReferReservation;
    customerBox: HTMLElement;
  };
  public utils: Utils = new Utils();

  @Watch("screenTabListUser")
  @Watch("screenTabListFactory")
  setScreenTab() {
    if (this.$route.meta == "user") {
      this.isUserMode = true;
      this.screenTab = this.screenTabListUser;
      this.currentTab = 0;
    } else {
      this.screenTab = this.screenTabListFactory;
      this.currentTab = 0;
    }
  }

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.socketEntry("confirmationSubscription", this.onConfirmationBeforeEntry); // catchSocket:ソケット仮19
    this.sktControll.socketEntry("frontSubscription", this.onFrontStaff); // catchSocket:ソケット仮25

    // ユーザー側かネクステージの時有効 (呼び出し先で判定する)
    this.sktControll.socketEntry("mileageSubscription", this.onMileage); // catchSocket:ソケット仮23
    this.sktControll.socketEntry("memoSubscription", this.onMemo); // catchSocket:ソケット仮24
    this.sktControll.socketEntry("inspectSubscriptionDetail", this.onStartInspect); // catchSocket:ソケット仮26
    this.sktControll.socketEntry("questionnaireSubscription", this.onQuestionnaire); // catchSocket:ソケット仮21
    this.sktControll.socketEntry("timeSubscription", this.onUpdateTime); // catchSocket:ソケット仮10
    // ここまで (呼び出し先で判定する)
    if (!this.isUserMode) {
      this.sktControll.socketEntry("youtoSubscription", this.onYouto); // catchSocket:ソケット仮20
    }
    this.sktControll.connectSocket();
  }

  created() {
    this.inspectionDetailStore.clearState();
    this.reqService = new requestService();
    this.service = new CustomerService();
    this.ippanSeibiService = new IppanSeibiService();
    const authContext = ShakenStorage.getActiveAuth(this.isUserMode ? "user" : "factory");
    const kyoten = authContext && authContext.kyotenCd;
    if (kyoten) {
      this.kyotenCd = kyoten;
    }

    this.setScreenTab();

    this.reqService.getStaffFront().then(
      (res: any) => {
        if (res) {
          this.staffs = res;
          this.initFrontStaff();
        }
      },
      (err: any) => {
        this.staffs = [];
      }
    );

    this.reqService.getKbnSkns("skn_shiyou_youto").then(
      (res: any) => {
        if (res && res.length > 0) {
          this.omonaYoutos = res;
        }
      },
      (err: any) => {
        this.omonaYoutos = [];
      }
    );

    this.reqService.getKbnSkns("skn_confirmation_before_entry").then(
      (res: any) => {
        if (res) {
          this.kbnConfirmations = res;
          this.mapConfirmation();
        }
      },
      (err: any) => {
        this.kbnConfirmations = [];
      }
    );

    let kbn1 = this.reqService.getSoukouBikou().then(list => {
      this.soukouBikouList = list;
      this.setSoukouData();
    });
    let kbn2 = this.reqService.getSoukouUnit().then(list => {
      this.soukouUnitList = list;
      this.setSoukouData();
    });

    this.reqService.getKbnSkns("skn_jidousha_shubetsu", "7101").then(
      (res: any) => {
        if (res) {
          this.$set(this, "kbnJidousha", res);
        }
      },
      (err: any) => {}
    );

    this.existingCreatedReload();
  }

  @Watch("$route")
  existingCreatedReload() {
    if (this.$route.name !== "customer" && this.$route.name !== "usercustomer") { return; }
    let promise1 = this.reqService
      .getReservationDetail(this.code, this.isUserMode)
      .then(
        (res: any) => {
          if ( !this.isUserMode ) {
            // ここでは工場のみ。ユーザー側は別機能で同じアクセスを行う
            this.reqService.openedReservationTarget(
              res.sknUketsukeExtends.id,
              {
                "pgtypeKbn": "login",
                "assignKbn": "factory"
              }
            );
          }
          if (res.header && res.header.login_group_code) {
            ShakenStorage.updateAuth({
              groupCd: res.header.login_group_code[0],
              shatenCd: res.header.login_shaten_code[0]
            }, this.isUserMode ? "user" : "factory");
          }

          this.initStore(res);
          this.connectSocket();
          this.initData();
          this.getSupportData();
          this.finishLoad = true;
        },
        (err: any) => {
          this.finishLoad = true;
          this.showError(err);
        }
      );

    let promise2 = this.kbnTitles.map(async (kbn: string) => {
      return this.reqService.getKbnSkns(kbn);
    });
    Promise.all(promise2).then((res: any) => {
      this.$set(this, "kbnSkns", res);
    });
    Promise.all([promise1]).then(() => {
      this.reqService
        .getCarSelection(this.uketsukeExtendsId)
        .then(
          (res: any) => {
            res.sknUketsukeExtendsId = +(this.uketsukeExtendsId);
            this.setCarSelection({ ...res, uketsukeCd: this.uketsukeCd });
            this.carForm = this.carSelection;
            this.setDefaultBtn();
            this.shashuRenban = this.carForm.shashuRenban;
            this.setProgressState({
              stateId: res.sknWorkProgressState,
              stateNm: res.sknWorkProgressStateNm
            });
            /** 2021-11-30 sh #7584 added jizen check. [START] */
            if (this.isCanJizenMitsumori) {
              const userService = new UserService();
              userService.getAllData();
            }
            /** 2021-11-30 sh #7584 added jizen check. [END] */
          },
          (err: any) => {
            console.log(err);
          }
        )
        .catch(error => {
          console.log(error);
        });
    });
  }

  setDefaultBtn() {
    // set default button value in carForm variable
    if (!this.carForm.shiftKbn) {
      this.carForm.shiftKbn = this.kbnSkns[3][0].kbnKey;
    }
    if (!this.carForm.kudouHoushiki) {
      this.carForm.kudouHoushiki = this.kbnSkns[1][0].kbnKey.toString();
    }
  }

  /**
   * サポート履歴データを取得し、割り当てる
   *
   * [2024/05/24] 通常・NEX仕様切替のため、UketsukeExtendsId基準に変更した
   */
  getSupportData() {
    let titleShort = "";
    let titleFull = "";
    this.reqService.getSupport2(this.uketsukeExtendsId).then((supports: any) => {
      if (supports.length) {
        // 内部supportの型推定がおかしくなるのでfor loopで実装
        // tslint:disable-next-line:prefer-for-of
        for (let i=0;i<supports.length;i++) {
          let support: any = supports[i];
          // 表示用初期化
          titleFull = support.memo.replace(/\\n/g, " ");
          const titleLength = this.utils.getUTF8Length(titleFull, 80);
          titleShort = titleFull.substr(0, titleLength.strCount);
          // 手動エスケープ(v-textだと不要だがv-htmlを使用するため必要)
          titleShort = titleShort.replace(/\</g, "&lt;");
          titleShort = titleShort.replace(/\>/g, "&gt;");
          titleShort = titleShort.replace(/\"/g, "&quot;");
          titleShort = titleShort.replace(/\'/g, "&apos;");
          titleFull = titleFull.replace(/\</g, "&lt;");
          titleFull = titleFull.replace(/\>/g, "&gt;");
          titleFull = titleFull.replace(/\"/g, "&quot;");
          titleFull = titleFull.replace(/\'/g, "&apos;");
          // 省略可否判定
          if ( titleLength.count > 80 ) {
            support.ommission = true;
          } else {
            support.ommission = false;
          }
          // アンカータグ処理
          let ankerBase = [];
          let ankerShort = [];
          let ankerFull = [];
          ankerBase = this.getUrlLink(support.memo);
          ankerShort = this.getUrlLink(titleShort);
          ankerFull = this.getUrlLink(titleFull);
          
          
          if ( this.isNextageCustom ) {
            // リンク書き換え
            titleShort = this.convertUrlLink( titleShort , ankerBase , ankerShort );
            titleFull = this.convertUrlLink( titleFull , ankerBase , ankerFull );

            // 年月日書き換え
            titleShort = this.convertDate( titleShort );
            titleFull = this.convertDate( titleFull );
          }
        
          support.memoShort = titleShort;
          support.memoFull = titleFull;
        }

        this.initSupport(supports);
      }
    });
  }

  get uketsuke(): Uketsuke {
    if (this.currentState) {
      return this.currentState.uketsuke;
    }
    return {};
  }

  get sknUketsukeExtends() {
    if (this.currentState && this.currentState.sknUketsukeExtends) {
      return this.currentState.sknUketsukeExtends;
    }
    return {};
  }

  mapConfirmation() {
    if (this.kbnConfirmations.length > 0 && this.yoyakuNo) {
      this.confirmations = [];
      this.kbnConfirmations.forEach((e: any, i: number) => {
        let val = 0;
        if (this.sknUketsukeExtends) {
          const extendsVal = (this.sknUketsukeExtends)[
            "confirmationBeforeEntry" + e.num
          ];
          if (extendsVal) {
            val = extendsVal;
          }
        }
        let entry: ConfirmationBeforeEntry = {
          num: e.num,
          id: this.uketsukeExtendsId,
          name: e.value,
          value: val,
          uketsukeCd: this.uketsukeCd,
          yoyakuNo: this.yoyakuNo
        };
        this.confirmations.push(entry);
      });
      this.isLoadConfirmation = true;
    }
  }

  mounted() {
    this.getQuestionare();
    this.$nextTick(() => {
      this.observeCustomerBoxHeight();
      this.updateStatusBoxHeight();
    });
  }

  get statusBoxStyle() {
    return this.statusBoxHeight ? { height: this.statusBoxHeight + "px" } : {};
  }

  @Watch("currentTab")
  @Watch("isShowMaintepack")
  updateStatusBoxHeightOnNextTick() {
    this.$nextTick(this.updateStatusBoxHeight);
  }

  observeCustomerBoxHeight() {
    if (!this.$refs.customerBox) { return; }

    const ResizeObserverConstructor = (window as any).ResizeObserver;
    if (typeof ResizeObserverConstructor === "undefined") {
      window.addEventListener("resize", this.updateStatusBoxHeight);
      return;
    }

    this.statusBoxResizeObserver = new ResizeObserverConstructor(() => {
      this.updateStatusBoxHeight();
    });
    this.statusBoxResizeObserver.observe(this.$refs.customerBox);
  }

  updateStatusBoxHeight() {
    const customerBox = this.$refs.customerBox;
    if (!customerBox) { return; }

    const height = customerBox.offsetHeight;
    this.statusBoxHeight = height > 0 ? height : null;
  }

  getQuestionare() {
    if (this.isUserMode) {
      this.timerGetQuestionare = setTimeout(() => {
        if (this.uketsukeExtendsId) {
          this.timerGetQuestionare = null;
          this.reqService
            .getQuestionnaireList(this.uketsukeExtendsId)
            .then((res: any) => {
              if (res) {
                const listQuestion = res.map((item: any) => {
                  const answer = item.answer.sort((a: any, b: any) => {
                    return a.displayOrder > b.displayOrder ? 1 : -1;
                  });
                  return { ...item, answer };
                });
                this.$set(this, "questionnaireList", listQuestion);
              }
            });
        } else {
          this.getQuestionare();
        }
      }, 1000);
    }
  }

  async setSoukouData() {
    const soukouUnitKbn = this.soukouUnitKbn || 1;
    if (this.sknUketsukeExtends.soukouBikouKbn) {
      this.soukouBikouKbn = +this.sknUketsukeExtends.soukouBikouKbn;
    } else if (this.soukouBikouList.length > 0) {
      this.soukouBikouKbn = +this.soukouBikouList[0].kbn;
    }
    if (this.sknUketsukeExtends.soukouUnitKbn) {
      this.soukouUnitKbn = +this.sknUketsukeExtends.soukouUnitKbn;
    } else if (this.soukouUnitList.length > 0) {
      this.soukouUnitKbn = +this.soukouUnitList[0].kbn;
    }
    this.updateSoukouUnitKbn(this.soukouUnitKbn);
    this.updateSoukouBikouKbn(this.soukouBikouKbn);
    this.updateSoukouUnitKbnMD3(this.soukouUnitKbn);
    this.updateSoukouBikouKbnMD3(this.soukouBikouKbn);
    if ( soukouUnitKbn === 1 && this.soukouKm && !this.soukouMile) {
      await this.convertMilesKm(this.soukouKm , soukouUnitKbn);
    } else if ( soukouUnitKbn === 2 && this.soukouMile && !this.soukouKm ) {
      await this.convertMilesKm(this.soukouMile , soukouUnitKbn);
    }
    this.saveTempSoukou();
  }

  async convertMilesKm(soukou: number, soukouUnitKbn: number) {
    // const soukouUnitKbn = this.soukouUnitKbn || 1;
    let soukouConv: any = await this.reqService.convertMiles_Km(
      soukou,
      soukouUnitKbn.toString()
    );
    if (soukouUnitKbn === 2) {
      this.soukouKm = soukouConv.km;
      this.soukouMile = soukou;
    } else {
      this.soukouKm = soukou;
      this.soukouMile = soukouConv.miles;
    }
    this.updateSoukouKm(this.soukouKm);
    this.updateSoukouMD3(this.soukouKm);
    this.updateSoukouMile(this.soukouMile);
    this.updateSoukouMileMD3(this.soukouMile);
  }

  saveTempSoukou() {
    this.tempKm = this.soukouKm;
    this.tempMile = this.soukouMile;
  }

  onExceedSoukou() {
    this.errorMsg = this.utils.msgExceedSoukou(this.soukouUnitKbn);
    this.$refs.errorDialog.onOpen();
  }

  onCloseMsg() {
    if (this.isExceed) {
      this.isExceed = false;
      this.$set(this, "soukouKm", this.tempKm);
      this.$set(this, "soukouMile", this.tempMile);
    }
  }

  initData() {
    if (this.sknUketsukeExtends) {
      this.getWorkProgressState();
      if (this.sknUketsukeExtends.sknMemo) {
        this.memo = this.sknUketsukeExtends.sknMemo;
      }
      if (this.sknUketsukeExtends.soukouKm) {
        this.soukouKm = this.sknUketsukeExtends.soukouKm;
      }
      if (this.sknUketsukeExtends.soukouMile) {
        this.soukouMile = this.sknUketsukeExtends.soukouMile;
      }
      this.setSoukouData();
      if (this.sknUketsukeExtends.omonaYouto) {
        this.omonaYoutoCd = this.sknUketsukeExtends.omonaYouto;
        // this.$set(this, "omonaYoutoCd", this.sknUketsukeExtends.omonaYouto)
        if (this.sknUketsukeExtends.omonaYoutoNm) {
          this.omonaYoutoNm = this.sknUketsukeExtends.omonaYoutoNm;
        }
      }
      if (!this.isUserMode && this.isReferReservation) {
        // 過去見積もり複製関連の処理
        if (this.sknUketsukeExtends.referReservationCnt) {
          this.referReservationCnt = this.sknUketsukeExtends.referReservationCnt;
        }
        if (this.sknUketsukeExtends.disableReferReservation) {
          this.disableReferReservation = this.sknUketsukeExtends.disableReferReservation;
        }
        if (this.sknUketsukeExtends.usedReferReservation) {
          this.usedReferReservation = this.sknUketsukeExtends.usedReferReservation;
        }
      }
      // 入庫前確認ダイアログのポップアップ（顧客詳細で最初に表示したタブのサブ項目が入庫前確認ならダイアログ表示）
      const tab0 = this.screenTab && this.screenTab[0];
      if (this.isUserMode && (tab0 && tab0.tab === 'reserve' && tab0.panel === 'confirm')) {
        this.displayDialogConfirmationBeforeEntry = true;
      }
      this.initFrontStaff();
    }
    setTimeout(() => {
      if (this.uketsukeCd) {
        this.mapConfirmation();
      }
    }, 250);
  }

  initFrontStaff() {
    if (
      this.sknUketsukeExtends.frontTantoushaCd &&
      this.sknUketsukeExtends.frontTantoushaNm &&
      this.staffs.length > 0 &&
      this.frontStaff != this.sknUketsukeExtends.frontTantoushaCd
    ) {
      let selectedStaff = this.staffs.find(
        (staff: Staff) =>
          staff.staffCd == this.sknUketsukeExtends.frontTantoushaCd
      );
      if (selectedStaff == null) {
        const staff: Staff = {
          staffCd: this.sknUketsukeExtends.frontTantoushaCd,
          staffNm: this.sknUketsukeExtends.frontTantoushaNm,
          kyotenCd: "",
          kyotenNm: ""
        };
        this.staffs.splice(0, 0, staff);
      }
      this.frontStaff = this.sknUketsukeExtends.frontTantoushaCd;
      this.frontStaffNm = this.storeFrontStaff;
      this.onUpdateFront(this.frontStaff);
    }
  }

  get customer() {
    if (this.currentState && this.currentState.customer) {
      return this.currentState.customer;
    }
    return {};
  }
  get customerCar() {
    if (this.currentState && this.currentState.customerCar) {
      return this.currentState.customerCar;
    }
    return {};
  }

  get support() {
    if (this.currentState) {
      return this.currentState.support;
    }
    return false;
  }

  getDate(strDate: string) {
    if (strDate) {
      return this.utils.formatDate(strDate, "M/D");
    }
    return "";
  }
  getTime(strTime: string) {
    if (strTime) {
      if (this.isNextageCustom && strTime == "00:00") { return "終日"; }
      return this.utils.removeLeadingZero(strTime.slice(0, 1)) + strTime.slice(1);// :00表示
    }
    return "";
  }
  selectTab(index: number ) {// 変更
    if (index !== this.currentTab) {
      this.currentTab = index;
      if (this.isActive=='sharyou' && this.reInitMd2) {
        this.resetMd2();
      }

      if ( this.isActive=='jizen' ) {
        /** 料金ランクが設定済みかチェックする。NGの場合、税金情報のダイアログを開いてさらに小窓を開く。 */
        if (this.isValidRyoukinRank()) {
          // this.getJizenMitsumoriPreview(); // 既に実行している
        } else {
          this.$refs.estimateDetail.showTaxDialog();
          
//          this.showDialogInspectionCost = true;
//          setTimeout(() => {
//            this.$refs.estimateInspectionCostComponent.showTaxDialog();
//          }, 500);
        }
      }
    }
  }

  isValidRyoukinRank() {
    if (this.sknUketsukeExtends && !this.sknUketsukeExtends.ryoukinRankCd) {
      return false;
    }
    return true;
  }

  // get visibleTabReserve() {// 予約情報　(アンケート)// 
  //  return this.currentTab == 1 || this.currentTab == 5;
  // }
  // get visibleTabSharyou() { // 車両情報// 
  //  return this.currentTab == 4;
  // }
  // get visibleTabJIzen() { // 概算見積
  //  return this.currentTab == 2 || this.currentTab == 3;
  // }
  // get visibleTabKousei() { // 検査構成
  //  return this.currentTab == 6;
  // }
  // isOldActive(index: number) {
  //  return this.currentTab == index;
  // }

  get isActive() {
    // this.currentTab
    if (this.screenTab.length == 0) { return false; }
    return this.screenTab[this.currentTab].tab;
  }

  onInspection() {
    if (this.finishLoad) {
      // factory
      if (this.isNoLaborRate) {
        this.displayDialogLaborRate = true;
        return;
      }
      if ( this.isReferReservation && this.checkReferReservation() ) {
        // 過去参照複製権を放棄していいか確認する
        this.dialogOk=false;
        this.showDialogReferCheck = true;
        return;
      }
      this.nextPage();
    }
  }

  nextPage() {
    this.$router.push({ name: "inspectiondetail" });
  }

  onStart() {
    // user
    // if (!this.isFutureDate()) {
      const userService = new UserService();
      if (
        !this.currentState.sknUketsukeExtends ||
        !this.currentState.sknUketsukeExtends.ryoukinRankCd
      ) {
        userService.getAllData(false);
      } else {
        userService.getAllData();
      }
      if (this.isNextageCustom) {
        this.$router.push({ name: "inspectioncost" });
      } else {
        this.$router.push({ name: "statusresult" });
      }
    // }
  }

  getStrLastMileage() {
    if (this.sknUketsukeExtends.zenkaiSoukouKm) {
      const km: number = +(this.sknUketsukeExtends.zenkaiSoukouKm);
      return this.utils.getNumberThousandSeparate(km) + "km";
    }
    return "";
  }
  heiseiDate(date: string) {
    return this.utils.getJapanDate(date, "YYYYMMDD");
  }

  async onChangeSoukoukm(soukou: number) {
    const soukouUnitKbn = this.soukouUnitKbn || 1;
    this.isExceed = this.utils.checkLimitSoukou(soukou, soukouUnitKbn);
    if (this.isExceed) {
      this.onExceedSoukou();
    } else {
      await this.convertMilesKm(soukou, soukouUnitKbn);
      this.onChangeSoukou();
    }
  }

  async onChangeSoukou() {
    let soukouKmAvg = this.utils.calSoukouAvg(
      this.soukouKm,
      this.sknUketsukeExtends,
      this.uketsuke
    );
    let soukouMileAvg = this.utils.calSoukouMileAvg(
      this.soukouMile || 0,
      this.sknUketsukeExtends,
      this.uketsuke,
    );
    this.updateSoukouKmAvg(soukouKmAvg);
    this.updateSoukouMileAvg(soukouMileAvg);
    this.updateSoukouUnitKbn(this.soukouUnitKbn);
    this.updateSoukouUnitKbnMD3(this.soukouUnitKbn);
    this.updateSoukouBikouKbn(this.soukouBikouKbn);
    this.updateSoukouBikouKbnMD3(this.soukouBikouKbn);
    this.saveTempSoukou();
    this.reqService.saveMileage( // sendSocket:ソケット仮23
      this.service.getPutParams({
        soukouKm: this.soukouKm,
        soukouKmAvg,
        soukouMile: this.soukouMile,
        soukouMileAvg,
        soukouUnitKbn: this.soukouUnitKbn,
        soukouBikouKbn: this.soukouBikouKbn
      })).then(
      (res: any) => {
        this.$message({
          message: MESSAGE.UpdatedSoukouKm,
          type: "info"
        });
      }, (err: any) => {
        this.showError(err);
      });
  }

  saveLaborRate() {
    let laborSelected = this.labors.find(
      (e: any) => e.laborRateCd == this.laborSelected
    );
    if (this.laborSelected && laborSelected) {
      // 車検点検:shakenTenken, 一般整備:seibi, 板金塗装:bankin, 保証:hoshou, クレーム:claim
      const laborRateKingaku = this.ippanSeibiService.isIppanSeibi? laborSelected.seibi:laborSelected.shakenTenken;
      this.reqService
        .saveRateKingakuZn({
          sknUketsukeExtendsId: this.uketsukeExtendsId,
          laborRateKingakuZn: laborRateKingaku,
          laborRateCd: laborSelected.laborRateCd
        })
        .then(
          (res: any) => {
            this.updateLaborRate(laborRateKingaku);
            this.displayDialogLaborRate = false;
          },
          (err: any) => {
            this.showError(err);
          }
        );
    }
  }

  getFullDate(date: string, format: string) {
    const formatDate = format ? format : "YYYYMMDD";
    if (date) {
      return this.utils.getFullDate(date, formatDate);
    } else {
      return "";
    }
  }

  getDaisha() {
    // if (this.uketsuke.daisha && Object.keys(this.uketsuke.daisha).length > 0) {
    //   return "あり";
    // }
    if (this.uketsuke.daishaRequireKbn === 1) {
      return "あり";
    }
    return "なし";
  }

  get IsHoujin(): boolean {
    if (this.uketsuke) {
      return this.uketsuke.kkKbn == 2;
    }
    return false;
  }

  get telSeparat() {
    if ( this.isNextageCustom ) {
      return "";
    } else {
      return "-";
    }
  }

  getAddress() {
    let zipno = this.uketsuke.kkZipNo;
    if (zipno && zipno.length > 3) {
      zipno = zipno.replace(/\b(\d{3})/g, "$1-");
    }
    return (
      "〒" +
      zipno +
      " " +
      this.uketsuke.kkPrefNm +
      this.uketsuke.kkAddr1 +
      this.uketsuke.kkAddr2
    );
  }

  setConfirm(index: number, val: number) {
    this.offNotify = true;
    // if (this.isUserMode) {
    if (this.confirmations[index].value == val) {
      val = 0;
    }
    this.confirmations[index].value = val;
    this.updateConfirmation({ num: index + 1, value: val });
    this.reqService.saveConfirmation(this.confirmations[index]).then( // sendSocket:ソケット仮19
      (res: any) => {},
      (err: any) => {
        this.showError(err);
      }
    );
    // }
  }
  getClassConfirm(index: number, val: number) {
    let cssClass = "";
    // if (!this.isUserMode) {
    //   cssClass = "disabled ";
    // }
    if (this.confirmations.length != 0) {
      if (this.confirmations[index].value == val) {
        cssClass += "primary-pushed";
      } else {
        cssClass += "normal";
      }
    }
    return cssClass;
  }

  convertUrlLink(target: string,urls: any, texts: any) {
    let i = 0;

    // 一旦別の文字列に置き換えて変換事故を防ぐ
    for ( i = 0 ; i < texts.length ; i++ ) {
      target = target.replace(texts[i], "<HREF" + i + ">");
    }

    // URLへの置換を実行
    for ( i = 0 ; i < texts.length ; i++ ) {
      target = target.replace("<HREF" + i + ">","<a target='blank' href='" + urls[i] +"'>" + texts[i] + "</a>");
    }

    return target;
  }

  // 日付だけのデータを特定文字+和暦の形に置き換える
  convertDate(target: string) {
    const ymdPattern = /^[0-9]{8}$/g;

    let matchs = ymdPattern.exec(target);
    if ( matchs != null ) {
      target = target.replace(matchs[0], "見積日：" + this.heiseiDate(matchs[0]));
    } 
    return target;
  }

  // 渡された文字列からURLを返す
  getUrlLink(target: string) {
    // 英字のみのURL_正規表現_Pattern
    const enUrlPattern = /https?:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+/g;
    // 日本語を含む正規表現_Pattern
    const jpUrlPattern = /https?:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+/g;
    let insertTitleMark = target.replace(/https?:\/\//g, "<$&"); // 1行に複数ある場合は個別に認識できるようにマーク挿入

    let lists = [];
    let j = 0;
    for ( let i = lists.length ; i <= lists.length ; i++ ) {
      let matchs = jpUrlPattern.exec(insertTitleMark);
      if ( matchs != null ) {
        for ( j = 0 ; j < matchs.length ; j++ ) {
          lists[lists.length] = matchs[j];
        }
        i += j - 1; // 複数回Hitしたときのカウンタ調整
      } 
    }
    return lists;
  }

  showMore(ommissionFlg: boolean, i: number) {
    if (
      ommissionFlg &&
      (this.supportSelected === null ||
        (this.supportSelected && this.supportSelected.index != i))
    ) {
      return true;
    } else {
      return false;
    }
  }

  showLess(ommissionFlg: boolean, i: number) {
    if (ommissionFlg) {
      return true;
    } else {
      return false;
    }
  }

  getSelectedStaff(staffCd: string) {
    let selectedStaff = this.staffs.filter(
      (staff: Staff) => staff.staffCd == staffCd
    );
    if (selectedStaff.length > 0) {
      return selectedStaff[0];
    }
  }

  onUpdateFront(value: string, sendAPI?: boolean) {
    if (this.frontStaff) {
      let selectedStaff = this.staffs.filter(
        (staff: Staff) => staff.staffCd == value
      );
      if (selectedStaff.length > 0) {
        this.frontStaffNm = selectedStaff[0].staffNm;
        this.updateFrontStaff({
          staffCd: value,
          staffNm: this.frontStaffNm
        });
        if (sendAPI) {
          this.offNotify = true;
          this.reqService
            .saveFrontTantousha( // sendSocket:ソケット仮25
              this.service.getPutParams({ frontTantoushaCd: this.frontStaff })
            )
            .then(
              (res: any) => {
                this.$message({
                  message: MESSAGE.UpdatedFrontTantousha,
                  type: "info"
                });
              },
              (err: any) => {
                this.showError(err);
              }
            );
        }
      }
    }
  }
  getTopic(index: number) {
    if (this.confirmations.length !== 0) {
      if (this.confirmations.length > index) {
        return this.confirmations[index].name;
      }
    } else if (this.kbnConfirmations.length > 0) {
      return this.kbnConfirmations[index].value;
    }
    return "";
  }

  getButtonName(index: number, isConfirm: boolean = true) {
    const arrNum = [0, 1, 2];
    if (arrNum.indexOf(index) > -1) {
      if (isConfirm) {
        return "確認";
      }
      return "未確認";
    } else {
      if (isConfirm) {
        return "あり";
      }
      return "なし";
    }
  }

  filterYouto() {
    return this.omonaYoutos.filter((e: any) => e.kbnKey === this.omonaYoutoCd);
  }

  updateStoreYouto() {
    this.updateOmonaYouto({
      omonaYouto: this.omonaYoutoCd,
      omonaYoutoNm: this.omonaYoutoNm
    });
  }

  changeOmonaYouto(value: any) {
    if (value) {
      const omonaYouto = this.filterYouto();
      if (omonaYouto.length > 0) {
        this.omonaYoutoNm = omonaYouto[0].value;
        this.updateStoreYouto();
        this.reqService
          .saveOmonaYouto( // sendSocket:ソケット仮20
            this.service.getPutParams({ omonaYouto: omonaYouto[0].kbnKey })
          )
          .then(
            (res: any) => {
              this.$message({
                message: MESSAGE.UpdatedOmonaYouto,
                type: "info"
              });
            },
            (err: any) => {
              this.showError(err);
            }
          );
      }
    }
  }

  onUpdateTime(frame: any) {
    // ネクステージの判定情報が遅れても正常判定できるよう、ユーザーかどうかここで判断する
    if (this.isUserMode || this.isNextageCustom ) {
      const body = this.utils.getWSData(frame);
      if (body.screenId == "1" && this.isUserMode) {
        this.reqService
          .getCarSelection(this.uketsukeExtendsId)
          .then((res: any) => {
            res.sknUketsukeExtendsId = +(this.uketsukeExtendsId);
            this.setCarSelection({ ...res, uketsukeCd: this.uketsukeCd });
            this.carForm = this.carSelection;
          });
      }
    }
  }

  onMileage(frame: any) {
    // ネクステージの判定情報が遅れても正常判定できるよう、ユーザーかどうかここで判断する
    if (this.isUserMode || this.isNextageCustom ) {
      const body = this.utils.getWSData(frame);
      this.soukouKm = +body.soukouKm;
      this.soukouMile = +body.soukouMile;
      this.soukouUnitKbn = +body.soukouUnitKbn;
      this.soukouBikouKbn = +body.soukouBikouKbn;
      this.updateSoukouKm(this.soukouKm);
      this.updateSoukouMD3(this.soukouKm);
      this.updateSoukouMile(this.soukouMile);
      this.updateSoukouMileMD3(this.soukouMile);
      this.updateSoukouUnitKbn(this.soukouUnitKbn);
      this.updateSoukouUnitKbnMD3(this.soukouUnitKbn);
      this.updateSoukouBikouKbn(this.soukouBikouKbn);
      this.updateSoukouBikouKbnMD3(this.soukouBikouKbn);
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedSoukouKm
      });
    }
  }

  onMemo(frame: any) {
    // ネクステージの判定情報が遅れても正常判定できるよう、ユーザーかどうかここで判断する
    if (this.isUserMode || this.isNextageCustom ) {
      const body = this.utils.getWSData(frame);
      this.memo = body.sknMemo;
      this.updateMemo(this.memo);
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedMemo
      });
    }
  }

  onConfirmationBeforeEntry(frame: any) {
    if (this.offNotify) {
      this.offNotify = false;
    } else {
      const body = this.utils.getWSData(frame);
      const index = body.num - 1;
      this.confirmations[index].value = body.value;
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedConfirmationBeforeEntry
      });
    }
  }

  onYouto(frame: any) {
    const body = this.utils.getWSData(frame);
    this.omonaYoutoCd = body.omonaYouto;
    this.omonaYoutoNm = body.omonaYoutoNm;
    this.updateStoreYouto();
    this.$notify.info({
      title: "Info",
      message: MESSAGE.UpdatedOmonaYouto
    });
  }

  onEnterSoukoukm() {
    this.$refs.inputSoukouKm.blur();
  }

  resetMd2() {
    this.inspectionDetailStore.clearState();
    this.$refs.inspectionDetail.initData();
    this.$forceUpdate();
  }

  onStartInspect(frame: any) {
    // ネクステージの判定情報が遅れても正常判定できるよう、ユーザーかどうかここで判断する
    if (this.isUserMode || this.isNextageCustom ) {
      const body = this.utils.getWSData(frame);
      if (this.$refs.startDialog) {
        this.$refs.startDialog.onOpen();
      }
      if (this.isActive=='kousei') {
        // 表示中の検査構成は自身の受信処理で未保存入力と調停する。
        if (!body || !body.selection) { this.resetMd2(); }
      } else {
        this.reInitMd2 = true;
      }

      /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
      if (body && body.seibiMenuCd) {
        this.inspectionDetailStoreService1.setSeibiMenuCd(body.seibiMenuCd);
      }
      /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
    }
  }

  onFrontStaff(frame: any) {
    if (this.offNotify) {
      this.offNotify = false;
    } else {
      const body = this.utils.getWSData(frame);
      this.$set(this, "frontStaff", body.frontTantoushaCd);
      this.onUpdateFront(body.frontTantoushaCd, false);
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedFrontTantousha
      });
    }
  }

  onQuestionnaire(frame: any) {
    // ネクステージの判定情報が遅れても正常判定できるよう、ユーザーかどうかここで判断する
    if (this.isUserMode || this.isNextageCustom ) {
      const body = this.utils.getWSData(frame);
      this.questionnaireList = body;
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedQuestionnaire
      });
    }
  }

  showError(error: any) {
    this.errorMsg = this.utils.getHttpErrorMessage(error);
    this.$refs.errorDialog.onOpen();
  }

  getWorkProgressState() {
    this.reqService
      .getSubHeaderData(this.uketsukeExtendsId, this.$route.meta)
      .then(
        (res: SubHeaderData) => {
          this.setProgressState({
            stateId: res.sknWorkProgressStateId,
            stateNm: res.sknWorkProgressStateNm
          });

          if (res.sknWorkProgressStateId && res.sknWorkProgressStateId > 0) {
            this.isRestart = true;
          }
          if (!this.isUserMode && this.isNoLaborRate) {
            this.reqService.getLaborRate().then((laborRate: any) => {
              if (laborRate && laborRate.length > 0) {
                this.$set(this, "labors", laborRate);
              }
            });
          }
        },
        (err: any) => {}
      );
  }

  get showPannel() {
    if (this.screenTab.length == 0) { return false; }
    return this.screenTab[this.currentTab].panel;
    // if (this.currentTab == 5) {
    //    return "question"; // アンケート
    // }
    // if (this.currentTab == 1) {
    //  if (this.isUserMode && !this.isNextageCustom ) {
    //    if (!this.isLoadConfirmation) {
    //      return "";
    //    } else {
    //      return "confirm"; // 入庫前確認
    //    }
    //  } else {
    //    return "support"; // 履歴、メモ
    //  }
    // }
    // return "";
  }

  showSupportSelected(item: any, i: number) {
    this.supportSelected = { ...item, index: i };
    // this.displayDialogSupport = true;
  }

  closeDialogSupport() {
    this.supportSelected = null;
    // this.displayDialogSupport = false;
  }

  get isNoLaborRate() {
    if (this.sknUketsukeExtends) {
      if (this.sknUketsukeExtends.laborRateCd) {
        // 削除済みや未登録のコード指定だと、コードだけ格納されていてこの先動作しないので追加でチェックする
        if (this.sknUketsukeExtends.laborRateKingakuZn) {
          return false;
        } else {
          return true;
        }
      } else {
        // レバレートコードもレバレート金額も未設定なら選択させる
        if (this.sknUketsukeExtends.laborRateKingakuZn) {
          return false;
        } else {
          return true;
        }
      }
    }
    return true;
  }

  onEnterSoukoukmDialog() {
    this.$refs.inputSoukouKmDialog.blur();
    setTimeout(() => {
      this.$refs.btnSoukouDialog.$el.focus();
    }, 100);
  }

  laborRateLabel(labor: any) {
    // 車検点検:shakenTenken, 一般整備:seibi, 板金塗装:bankin, 保証:hoshou, クレーム:claim
    const laborRateKingaku = this.ippanSeibiService.isIppanSeibi? labor.seibi:labor.shakenTenken;
    return (
      labor.bunruiNm + " " + this.utils.getNumberThousandSeparate(laborRateKingaku)
    );
  }

  activeKudouHoushiki(kbn: KbnSkn) {
    if (!this.carForm.kudouHoushiki) {
      return kbn.num == 1;
    } else {
      return +this.carForm.kudouHoushiki == kbn.kbnKey;
    }
  }

  activeShift(kbn: KbnSkn) {
    if (!this.carForm.shiftKbn) {
      return kbn.num == 1;
    } else {
      return +this.carForm.shiftKbn == kbn.kbnKey;
    }
  }

  saveQuestionnaire() {
    // sendSocket:ソケット仮21
    this.reqService.saveQuestionnaire(this.questionnaireList);
  }

  destroyed() {
    if (this.timerGetQuestionare) {
      clearTimeout(this.timerGetQuestionare);
    }
    if (this.statusBoxResizeObserver) {
      this.statusBoxResizeObserver.disconnect();
    }
    window.removeEventListener("resize", this.updateStatusBoxHeight);
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => { // sendSocket:32車検中止
      if (this.isUserMode) {
        this.$router.push({ name: "reservationNumber" });
      } else {
        this.$router.push({ name: "reservation" });
      }
    });
  }

  checkIsCanJizen() {
    return this.isCanJizenMitsumori && this.inspectionDetailStoreService2.isDoJizen;
  }

  onCancelStart() {
      this.reqService
        .getInsectionDetail(this.uketsukeExtendsId)
        .then((data: any) => {
          this.inspectionDetailStoreService2.setJizenCd(data.jizenCd);
          this.currentTab = 0;
        });
  }
  
  /** 2022-11-30 sh #8122(BQR982) show dialog and reload after change shaken shurui. [END] */
  /* 途中保存して戻す処理 */
  onSave() {
    this.$refs.dialog.onOpen();
  }
  onSubmit() {
      this.reqService.updateSknWorkProgressStateOnHold(this.uketsukeExtendsId).then(
        (res: any) => {
          this.$router.push({ name: "reservation" });
        },
        (err: any) => {
        }
      );
  }
  /* ここまで */
  
  // 過去見積もり参照データモーダルを開く
  onOpenReferReservation() {
    this.$refs.referReservation.open();
  }

  // 過去見積もり参照の条件確認
  checkReferReservation() {
    // isRestart が再開ではなくスタート判定で
    // referReservationCnt が0件でなく
    // disableReferReservation 等不許可の指示が出てなければ選択可能
    return !this.isRestart &&  this.referReservationCnt > 0 
      && !this.disableReferReservation && !this.usedReferReservation;
  }

  // 過去見積もりエラー時
  onErrorReferReservation(error: any) {
    this.showError(error);
    this.disableReferReservation = true;
    this.$refs.referReservation.closeDialog();
  }

  onShowPrintJizenMitsumori() {
    this.$refs.estimateDetail.onShowPrintJizenMitsumori();
  }

  // どこから表示したかで求められる「戻る」の動きが異なる
  routerBack() {
    if (this.isUserMode) {
      this.$router.go(-1);
    } else {
      // ブラウザバック時の履歴を保持するため、replaceではなくpushで遷移する
      this.$router.push("/factory/reservation");
    }
  }

}
